import type { MailboxInfo } from 'owa-client-types';
import { isUserAllowedToChangeSettings, OcpsPolicyFeature } from 'owa-owsprime-policies-store';

export default function isUserAllowedToChangeFocusedInbox(mailboxInfo: MailboxInfo): boolean {
    return isUserAllowedToChangeSettings(OcpsPolicyFeature.FocusedInbox, mailboxInfo);
}
